// TODO: 日文文案待产品确认，暂与中文设计稿保持一致
export default {
  tabTitle: '岗位匹配',
  tabs: {
    recommend: '推荐',
    communicating: '沟通中',
    pendingApply: '待投递',
    applied: '已投递',
    notConsider: '暂不考虑',
  },
  updatedAt: '更新于 {time}',
  refreshing: '匹配度刷新中 {finished}/{total}',
  refreshFailed: '{count} 个职位的匹配度刷新失败',
  refresh: '刷新',
  addCommunicatingJob: '添加沟通职位',
  columns: {
    job: '求人',
    enterprise: '募集企業',
    matchScore: '匹配度',
    memo: 'メモ欄',
    notConsiderReason: '不考虑原因',
    notConsiderRemark: '补充说明',
    publish: '掲載ページ',
    residence: '在留資格',
    japaneseLevel: '日本語レベル',
    position: '職種・ポジション',
    workLocation: '勤務地',
    salary: '月総支給額（税引き前）',
    industry: '业界',
    businessType: '业种',
    updateTime: '更新时间',
    updater: '更新人',
    operation: '操作',
  },
  published: '掲載中',
  unpublished: '未掲載',
  actions: {
    detail: '详情',
    interested: '感兴趣',
    notConsider: '暂不考虑',
    apply: '投递',
    agreeApply: '同意投递',
    reCommunicate: '重新沟通',
  },
  notConsiderReasons: {
    notInterested: '不感兴趣',
    notMatch: '不匹配',
    other: '其他',
  },
  interestedDialog: {
    title: '标记感兴趣',
    description: '将职位「{jobId}」标记为感兴趣',
  },
  notConsiderDialog: {
    title: '暂不考虑',
    description: '暂不考虑投递职位「{jobId}」',
    reason: '不考虑原因',
    remark: '补充说明',
  },
  reCommunicateDialog: {
    title: '重新沟通',
    content: '确认重新沟通后，职位「{jobId}」将被移动到沟通中列表，确认重新开始沟通吗？',
  },
  addCommunicatingDialog: {
    title: '添加沟通职位',
    enterprise: '応募企業',
    job: 'ポジション',
  },
  pleaseSelectReason: '不考虑原因を選択してください',
  pleaseSelectEnterprise: '応募企業を選択してください',
  pleaseSelectJob: 'ポジションを選択してください',
  applyDialog: {
    aiGenerate: 'AI 自動生成',
    authorized: '用户已授权投递',
    pleaseConfirmAuthorized: '请确认用户已授权',
  },
  aiReasonDialog: {
    title: 'AI 自动生成推荐理由',
    meeting: '面谈纪要',
    tip: '注：仅支持选择面谈纪要不为空的面谈。',
    generate: '生成',
    pleaseSelectMeeting: '面谈纪要を選択してください',
  },
}
